module.exports = __webpack_public_path__ + "static/media/delete_icon_disabled.768b2cce.svg";